export const AccountSettingDefaultProps = {
    background:null,
    _id: undefined,
};

export default {
    AccountSettingDefaultProps
};